import JvmMemory from './JvmMemory.vue';
export default JvmMemory;
